import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerDynamicComponentsPage from "../pages/DsokCustomerDynamicComponentsPage";

export const dsokCustomerDynamicComponentsRoute = {
  path: "/dsok/customer-detail/:customerUrl/dynamic-components",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerDynamicComponentsPage} />
    </DsokCustomerDetailProvider>
  ),
};
